import { render } from "./Hujan.vue?vue&type=template&id=1495d8fc"
import script from "./Hujan.vue?vue&type=script&lang=js"
export * from "./Hujan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__